import { theme } from "@project/shared";
import Head from "next/head";
import styled from "styled-components";

const Wrapper = styled.div`
  padding: 24px 15.28% 144px;
  justify-content: center;
  display: flex;
  @media (max-width: 1375px) {
    padding: 24px 120px 144px;
  }
  @media (max-width: 1075px) {
    padding: 24px 80px 80px;
  }
  @media (max-width: 920px) {
    padding: 24px 26px 80px;
  }
  @media (max-width: 768px) {
    padding: 24px 0px 60px;
  }
`;
const Container = styled.div`
  flex: 1;
  max-width: 1240px;
  & > div {
    box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.05);
  }
  & ul {
    list-style: none;
  }
`;
const Header = styled.div`
  background: ${theme.base};
  padding: 16px;
  margin-bottom: 24px;
  font-size: 18px;
  line-height: 150%;
  color: ${theme.planeText};
`;
const Content = styled.div`
  background: ${theme.base};
  padding: 16px 16px 39px;
  & p,
  li {
    font-size: 14px;
    line-height: 150%;
    color: ${theme.black};
  }
  & li {
    margin-bottom: 12px;
  }
  & ol {
    margin-bottom: 24px;
    padding-left: 32px;
  }
`;
const Text = styled.p<{ list?: boolean }>`
  margin-bottom: ${({ list }) => (list ? "12px" : "24px")};
  white-space: break-spaces;
`;
const LastTextWrapper = styled.div`
  & p {
    margin-bottom: 12px !important;
  }
`;
const Terms = () => {
  return (
    <Wrapper>
      <Head>
        <title>side bizz会員規約 | side bizz</title>
      </Head>
      <Container>
        <Header>side bizz 会員規約 </Header>
        <Content>
          <Text list>第 1 条（定義）</Text>
          <Text>
            「side
            bizz（以下「本サイト」といいます。）」とは、ウェブエックス株式会社（以下「当社」といいます。）が運
            営するインターネット上の情報サービス（https://www.sidebizz.net/）を指します。なお、本サイトに付随するサー
            ビスには、掲載情報の提供、掲載元（以下「掲載企業」といいます。）と
            side bizz 会員（以下「会員」といいま
            す。）のマッチングサービス、会員向けのメッセージ配信、プラットフォームの提供など（以下まとめて「本サービ
            ス」といいます。）が含まれます。
          </Text>
          <Text list>第 2 条（会員）</Text>
          <ol>
            <li>
              会員とは、本サイトに自己の情報を当社が指定する手続きにより登録（以下「会員登録」といいます。）し、当社
              が承認した 18 歳以上の個人、又は法人をいいます。
            </li>
            <li>
              会員は本サイトに会員登録した時点で、本サイトの会員規約、およびプライバシーポリシーの内容にすべて承諾し
              たものとみなされます。不承諾の意思表示は本サイトに会員登録しない、又は退会することによってのみ認められま
              す。
            </li>
            <li>
              本サービスは、必ず会員本人が利用するものとし、代理人や第三者（当社及び会員以外の全て）による利用は認め
              られないものとする。
            </li>
            <li>
              当社は会員に対し、サービス利用の為のＩＤ及びパスワードを発行し付与する。会員は、自己のＩＤ及びパスワー
              ドの使用及び管理について、一切の責任を負うものとする。なお、ＩＤ及びパスワードを第三者に使用されたことに
              よる一切の費用や損害を会員自身の責任で全て負担するものとし、当社は一切の責任を負わないものとする。
            </li>
          </ol>
          <Text list>第 3 条（マスター会員）</Text>
          <ol>
            <li>
              マスター会員とは、当社と契約締結した法人会員（株式会社、有限会社、合同会社、社団法人など）のことをい
              う。
            </li>
            <li>
              マスター会員を経由して登録された会員は、一般的な会員ではなく、マスター会員に内包された会員（以下「子会
              員」といいます。）と定義する。
            </li>
            <li>
              マスター会員は、子会員が正しく本サイトや本サービスを利用するように監督・指導する義務を負う。
            </li>
            <li>
              マスター会員は、契約プランに応じた利用料金、又は見積もり提示された利用料金を、当社指定の期日までに支払
              うものとする。なお、契約プランを途中で変更した場合、再契約手続きが完了した月の翌月初から適用されるものと
              する。
            </li>
            <li>
              マスター会員の最低契約期間は 3
              ヶ月（それぞれ月初～月末の契約）で、契約は 1 法人又は 1 部署につき
              1 契約と する。なお、最低契約期間の後は 1 ヶ月毎の自動更新とする。
            </li>
            <li>月中契約の場合には日割り料金とする。</li>
            <li>
              利用料金の支払いは、原則的に毎月 25
              日のクレジットカード引き落としとする。なお、当社が事前承諾した場合
              のみ例外もあり得るが、銀行振込の手数料はマスター会員の負担とする。
            </li>
            <li>
              マスター会員を解約したい場合、毎月 20
              日までに当社へ申し出ることで、翌月分から解約できるものとする。な
              お、最低契約期間は解約できないものとする。
            </li>
          </ol>
          <Text list>第 4 条（会員登録および削除・利用停止）</Text>
          <ol>
            <li>
              本サービスの利用者は、自らの意思および責任をもって本サイトに会員登録し、登録した会員情報はすべて会員自
              らがその内容の正確性・真実性・最新性等一切の責任を負うものとする。
            </li>
            <li>
              会員は本サイトに会員登録した情報を適時変更・追加・削除して最新情報に保つものとする。なお、会員がこれら
              の処置を怠ったことに起因した、会員や第三者が被る損害について、当社は一切の責任を負わないものとする。
            </li>
            <li>
              会員の本サービス利用方法について、当社が不適当と判断した場合､又は本規約で定める会員の禁止行為に該当した
              場合、当該会員に対し事前通知なしで当該登録情報の全部又は一部を削除・利用停止することにつき、会員はあらか
              じめ承諾するものとします｡
              なお、当社がこれらの処置を行うにあたって生じる会員や第三者が被る損害、又は全権
              利の消失について、当社は一切の責任を負わないものとする。
            </li>
            <li>
              以下の個人・法人は本サイトに会員登録できないものとする。また、以下に該当すると当社が判断した場合、当該
              会員に対し事前通知なしで当該登録情報の全部又は一部を削除・利用停止できるものとする。
            </li>
            <ul>
              <li>
                ①
                暴力団等（暴力団、暴力団員、暴力団関係企業・団体又はその関係者、その他反社会勢力）である方
              </li>
              <li>
                ② 反社会的活動と関わっている方、又はその活動に過去関係していた方
              </li>
              <li>③ 過去に当社の判断で会員登録を削除・利用停止された方</li>
              <li>④ 当社や掲載企業の業務を妨害する方</li>
              <li>⑤ 就労ビザを有していない、又は不法就労している外国人</li>
              <li>⑥ 会員規約に違反している方</li>
              <li>⑦ その他当社が適当でないと判断した方</li>
            </ul>
          </ol>
          <Text list>第 5 条（退会）</Text>
          <ol>
            <li>
              会員が退会を希望する場合、当社の指定した方法で自ら退会手続きをする。
            </li>
            <li>
              当社は会員からの退会の申し出を受理した後、5
              営業日以内に当該会員に関する個人情報をデータベースから削除
              する。なお、バックアップデータには一定期間、当該会員に関する個人情報が残存してしまう可能性があることをあ
              らかじめ承諾する。
            </li>
            <li>
              会員は未受領の報酬、会員ランク、口コミや評価、特典、景品、実績、取得権利、又は本サービスの利用に関する
              全ての権利を退会時に無条件放棄する。なお、会員が再登録した場合においても、失効した情報や権利については復
              帰しないものとし、例外は一切認められないものとする。
            </li>
            <li>
              当社は理由の如何を問わず、本条に基づく退会によって生じる会員への報酬補填、損害賠償、損失補償、その他一
              切の責任や保証を負わないものとする。
            </li>
            <li>
              当社は、会員が退会したことに伴う掲載企業、又は第三者とのトラブルについて一切関与しないものとする。
            </li>
          </ol>
          <Text list>第 6 条（個人情報の取扱い）</Text>
          <ol>
            <li>
              当社は「プライバシーポリシー（個人情報保護方針）」に則り会員の個人情報を取り扱うものとする。
            </li>
            <li>
              当社は、会員の登録情報を、会員に対する本サービス提供および本サービス運営に必要な範囲内で利用する。
            </li>
            <li>
              当社は、特定の個人や法人と識別できない状態であれば、会員の登録情報を統計情報・属性情報として活用できる
              ものとし、会員はあらかじめこれに承諾する。
            </li>
            <li>
              会員が本サービスを利用した場合、該当する掲載企業に、最新の会員登録情報や会員が本サイトで入力した情報が
              開示されることをあらかじめ承諾する。
            </li>
            <li>
              掲載企業に開示された会員情報は、その掲載企業が責任をもって取り扱いする。仮に、掲載企業の過失によって開
              示された情報の漏洩その他一切の問題が発生した場合でも、会員と掲載企業が直接解決するものとし、当社はこの問
              題に起因する会員又は掲載企業の損害について、一切の責任を負わないものとする。
            </li>
          </ol>
          <Text list>第 7 条（本サービス利用について）</Text>
          <ol>
            <li>
              会員は本サービスで提供されている情報の最新性、真実性、合法性、安全性、信頼性、確実性、および事業性につ
              いて当社が何ら保証しないことを了承の上、自己の責任と判断において利用する。
            </li>
            <li>
              会員は本サイトを利用する上で発生する本サービスの効果一切について、その確実性が保証されていないことをあ
              らかじめ了承した上で本サービスを利用する。
            </li>
            <li>
              会員は、本サービスを利用する上で発生する費用や責任を自身で担うものとし、当社や掲載企業に風評被害や経済
              的損失を与えないように細心の注意を払うものとする。
            </li>
            <li>
              会員は本サービスの利用開始をもって、本サービスに関連する案内やシステムメール、スカウトメールを受け取る
              ことにあらかじめ承諾する。
            </li>
            <li>
              当社は「会員規約の変更」「報酬条件の変更」など会員が本サービスを利用する上で重要と判断した情報を本サイ
              ト上に掲示したり、メールや書面で随時通知できるものとする。なお当社は、この重要情報を会員が失念したり、見
              落としたことによる報酬補填、損害賠償、損失補償、その他一切の責任を負わないものとする。
            </li>
          </ol>
          <Text list>第 8 条（リファラル営業）</Text>
          <ol>
            <li>
              リファラル営業とは、本サイトに掲載されている掲載企業の製品・サービス（以下「商材」といいます。）を知
              人・友人などに紹介する行為をいう。
            </li>
            <li>
              会員はリファラル営業する商材を自らの意思で選定し、自らの資金と責任で行動する。
            </li>
            <li>
              リファラル営業は、あくまでも会員自身による任意行為とする。ただし、掲載企業から固定報酬が通知され、その
              報酬額と要望に会員自身が同意した場合、依頼内容に対して誠実に対応し、その結果を掲載企業に報告するように努
              めるものとする。
            </li>
            <li>
              リファラル営業は、会員自身の人脈・販路に限って行うものとする。なお、掲載企業が承諾した場合には例外もあ
              り得るものとする。
            </li>
            <li>
              リファラル営業によって見つけた見込顧客は、本サービスを通じて掲載企業に引き継ぐものとする。
            </li>
            <li>
              掲載停止された商材は、その時点からリファラル営業できないものとする。
            </li>
          </ol>
          <Text list>第 9 条（リファラル営業の報酬）</Text>
          <ol>
            <li>
              会員は本サイトに明記された所定の報酬を、リファラル営業の実績に応じて受け取れるものとする。なお、「会員
              の禁止行為」に該当した場合、又は「子会員」だった場合には報酬が支払われないものとする。
            </li>
            <li>
              子会員の報酬は、マスター会員にまとめて支払われるものとする。
            </li>
            <li>
              会員は報酬の受領代行業務を当社に委託するものとし、掲載企業から直接受け取ることを一切禁止する。
            </li>
            <li>
              報酬は、支払い処理する際に当社が登録確認した会員指定の銀行口座に振り込むものとする。なお、振込み
              1 回に つき一律 300 円の振込手数料を差し引くものとする。
            </li>
            <li>
              会員が指定できる口座は日本国内の銀行口座、かつ会員名義と同一のみ有効とし、個人会員は個人口座、法人会員
              は法人口座とする。なお、会員名や属性(個人・法人)と口座名義が一致しない場合、報酬は支払われないものとす
              る。
            </li>
            <li>
              リファラル営業の実績に応じて会員に支払われる報酬は、以下の通りとする。
            </li>
            <ul>
              <li>
                ①
                固定報酬（掲載企業の報酬通知に同意した日を起点とした翌々月末日までに支払い）
              </li>
              <li>
                ②
                成果報酬（掲載企業から報酬通知された日を起点とした翌々月末日までに支払い）
              </li>
            </ul>
            <li>
              会員に支払う報酬が継続報酬（ストック報酬）であった場合、見込顧客が解約した時点から報酬受け取りの権利も
              無くなるものとする。
            </li>
            <li>
              会員に支払う報酬は、毎月精算されるものとする。なお、支払うべき報酬がない場合は振り込まれないものとす
              る。
            </li>
            <li>
              成果報酬の対象となる見込顧客の定義は、本サービスを通じて会員が掲載企業に紹介した日を起点とし、1
              年以内 に報酬実績として集計された場合のみとする。よって、1
              年を超えても掲載企業から報酬通知されなかった見込顧客
              は、全て実績対象外とする。
            </li>
            <li>
              会員が指定した口座情報が有効ではなかった場合、報酬は支払われないものとする。なお、不備が解消されたと
              当社が把握できた場合、その翌々月末日までに報酬が支払われるものとする。
            </li>
            <li>
              口座情報の不備が原因で、掲載企業から報酬通知を受領した日を起点として
              180 日間が経過しても当社からの振
              込み手続きが完了しなかった場合、当社は会員が報酬を受け取る権利を自ら放棄したとみなし、会員も権利放棄を意
              思表示したこととする。また、会員から報酬の受け取る権利を放棄したい旨を通知された場合も同様とする。
            </li>
            <li>
              掲載企業が次の各号のいずれかに該当した場合、当社は以降の報酬の支払いを免除されるものとする。
            </li>
            <ul>
              <li>
                ①
                掲載企業が報酬や利用料金その他本サービス利用契約に基づく支払債務の履行を怠った場合
              </li>
              <li>
                ②
                掲載企業が差押、仮差押、仮処分もしくは競売の申立を受けたとき、又は公租公課滞納による処分を受けた場合
              </li>
              <li>
                ③
                掲載企業が銀行や手形交換所から取引停止処分を受けたとき、又は支払不能に陥った場合
              </li>
              <li>
                ④
                掲載企業が振出し、引受け、保証し、又は裏書した手形、小切手が不渡りになった場合
              </li>
              <li>
                ⑤
                掲載企業が特別清算、会社更生手続、民事再生手続、破産、又はこれらに準ずる法律上の手続きの開始を申
                立て、もしくは申し立てられた場合
              </li>
              <li>
                ⑥
                掲載企業の資産、信用、支払能力等に重大な変更が生じたとき、その他信用状態に著しい不安が生じた場合
              </li>
            </ul>
          </ol>
          <Text list>第 10 条（免責）</Text>
          <ol>
            <li>
              当社は、以下の各号に伴い本サービスを一時的に中止、変更、廃止できるものとする。なお、その際に発生した損
              害等について、理由の如何を問わず、一切の責任を負わないものとする。
            </li>
            <ul>
              <li>① システムの点検又は保守作業を定期的又は緊急に行う場合</li>
              <li>
                ②
                ウィルス被害、不正アクセス、自然災害、天変地異、その他当社の責によらない事由によって本サービス運営が
                困難な場合
              </li>
              <li>③ その他、当社が必要やむをえないと認めた場合</li>
            </ul>
            <li>
              当社は、以下の各号に伴い発生した損害等について、理由の如何を問わず、一切の責任を負わないものとする。
            </li>
            <ul>
              <li>
                ①
                本サービスを通じて、会員間、又は会員と第三者、又は掲載企業との間でトラブルが発生した場合
              </li>
              <li>
                ②
                本サービスからリンクされた当社以外のウェブサイト利用に伴うトラブルが発生した場合
              </li>
              <li>③ 本サービスの登録データが消失した場合</li>
              <li>
                ④
                本サービス、当社システムへの不正アクセス、ウィルスの侵入等が発生した場合
              </li>
              <li>⑤ 本サービスが中断、停止、終了した場合</li>
            </ul>
          </ol>
          <Text list>第 11 条（会員の禁止行為）</Text>
          <ol>
            <li>
              本条は本サイト、又は本サービスを利用する上で会員が必ず遵守すべき事項とする。
            </li>
            <li>リファラル営業を行う上で以下の行為を禁止する。</li>
            <ul>
              <li>
                ①
                アフィリエイト広告やリスティング広告などの有料広告を使って見込顧客を集客する行為
              </li>
              <li>
                ② ブログや SNS
                などインターネットを活用した告知や宣伝で見込顧客を集客する行為
              </li>
              <li>③ 独自の販促資料を作成してリファラル営業する行為</li>
              <li>
                ④
                本サービスを介さず、掲載企業に見込顧客を引き継ぐ、又は報酬を受け取る行為
              </li>
              <li>⑤ 掲載企業の商材に全く興味がない見込顧客を引き継ぐ行為</li>
              <li>⑥ 誤解を招くような表現や、嘘をついて興味を引く行為</li>
              <li>⑦ 見込顧客に報酬の一部を還元するような行為</li>
              <li>⑧ 不正に報酬を得る目的で見込顧客を紹介する行為</li>
              <li>⑨ 実在しない、又は架空の見込顧客を紹介する行為</li>
              <li>⑩ その他会員規約に反する行為</li>
            </ul>
            <li>本サイトを利用する上で以下の行為を禁止する。</li>
            <ul>
              <li>
                ①
                会員登録時に虚偽の情報を登録する、又は架空の人物として本サイトを利用する行為
              </li>
              <li>② 自己以外の情報を登録する行為</li>
              <li>
                ③
                当社、他の会員又は第三者の著作権、肖像権、その他知的所有権を侵害する行為
              </li>
              <li>
                ④ 当社、他の会員又は第三者の財産、プライバシー等を侵害する行為
              </li>
              <li>
                ⑤
                当社、他の会員又は第三者を誹謗中傷する行為及び当社に対する権利侵害行為
              </li>
              <li>
                ⑥ 法令、社会常識、公序良俗に違反する行為、又はその恐れがある行為
              </li>
              <li>⑦ 宗教活動、又は政治団体への勧誘行為</li>
              <li>
                ⑧
                本サイトを通じて入手した情報を、複製、販売、出版するなど再利用する行為
              </li>
              <li>
                ⑨
                本サイトを利用した自己の営業活動、売り込み、営利を目的とする行為
              </li>
              <li>
                ⑩ 本サイトの運営を妨げる、又は本サイトの信頼を毀損する行為
              </li>
              <li>
                ⑪
                相手方に対する不誠実な対応や行為、又はクレームを誘発するような対応や行為
              </li>
              <li>
                ⑫
                コンピューター・ウィルスその他の有害なコンピューター・プログラムを含む情報を送信する行為
              </li>
              <li>⑬ 会員本人ではない、代理人や第三者に利用させる行為</li>
              <li>⑭ 同一人物が 2 つ以上の会員登録をする行為</li>
              <li>⑮ 当社が指定する利用方法と異なる行為</li>
              <li>⑯ 機密情報を第三者に開示・漏洩する行為</li>
              <li>⑰ その他会員規約に反する行為</li>
            </ul>
          </ol>
          <Text list>第 12 条（本サービスの中断・停止又は廃止）</Text>
          <ol>
            <li>
              当社は独断で本サービスの中断又は停止を随時行うことができるものとする。
            </li>
            <li>
              前項のほか、以下のいずれかに該当する場合には、当社は会員に通知することなく、本サービスの全部又は一部を
              中断又は停止できるものとする。
            </li>
            <ul>
              <li>
                ①
                システムのリニューアル、点検又は保守作業を定期的又は緊急に行う場合
              </li>
              <li>
                ②
                停電、サーバー故障、システム障害、回線障害、火災、停電、天災地変、通常合理的に講ずるべき対策では防止
                できないウィルス、不正アクセス、妨害行為その他不可抗力等など当社の責に帰さない事由により本サービスの
                運営ができなくなった場合
              </li>
              <li>
                ③
                経営事情又は本サービスの運営上の事情により、本サービス停止又は中断が必要であると当社が判断した場合
              </li>
            </ul>
            <li>
              当社は 30
              日前に通知することにより、本サービスをいつでも廃止できるものとする。
            </li>
            <li>
              当社は本条に基づき当社が行った措置について、報酬補填、損害賠償、損失補償、その他一切の責任を負わないも
              のとする。
            </li>
          </ol>
          <Text list>第 13 条（事業委託・事業譲渡）</Text>
          <ol>
            <li>
              当社は本サービスの運営・提供に関して、全部又は一部の業務を外部委託できるものとする。
            </li>
            <li>
              当社は、本サービスを第三者に譲渡した場合、本サービスの運営者たる地位、本規約上の地位、本規約に基づく権
              利、義務ならびに登録情報およびその他情報を、当該第三者に譲渡することができるものとし、会員は、本規約への
              同意を以て当該譲渡についてあらかじめ同意する。なお、本条に定める事業譲渡には、通常の事業譲渡のみならず、
              会社分割その他事業が移転する場合などを含むものとする。
            </li>
          </ol>
          <Text list>第 14 条（第三者に対する責任）</Text>
          <Text>
            会員が本サイトの登録、利用により、第三者に対して損害を生じさせた場合には、会員の責任において解決するもの
            とし、当社は一切の責任を負わないものとする。
          </Text>
          <Text list>第 15 条（損害賠償））</Text>
          <Text>
            会員が、本規約に違反したことで当社に損害を与えてしまった場合、会員は当社に対し直接・間接を問わず一切の損
            害の賠償義務を負うものとする。
          </Text>
          <Text list>第 16 条（会員規約の変更）</Text>
          <ol>
            <li>
              当社は本規約を随時変更することができるものとします。会員は会員規約が変更された後もサービスを利用する場
              合、変更された会員規約に全て承諾したものとみなされます。
            </li>
            <li>
              当社は本規約を変更する際、本サイトにアップロードするなど当社が適当と認める方法によって開示、又は通知す
              る。
            </li>
          </ol>
          <Text list>第 17 条（準拠法および管轄）</Text>
          <Text>
            本サービスおよび会員規約の準拠法は日本法とし、本サービスに関して生じる一切の紛争については、東京地方裁判
            所又は東京簡易裁判所を第一審の専属的管轄裁判所とする。
          </Text>
          <Text list>附則</Text>
          <LastTextWrapper>
            <p>2018 年 6 月 1 日作成</p>
            <p>2018 年 12 月 15 日改訂</p>
            <p>2019 年 5 月 1 日改訂</p>
            <p>2020 年 3 月 15 日改訂</p>
            <p>2021 年 1 月 1 日改訂</p>
            <p>2021 年７月 31 日改訂</p>
          </LastTextWrapper>
        </Content>
      </Container>
    </Wrapper>
  );
};

export default Terms;
